/* eslint-disable eqeqeq */
/* eslint-disable no-magic-numbers */
/* eslint-disable no-implicit-coercion */
/* eslint-disable no-unused-vars */
/* eslint-disable capitalized-comments */
/* eslint-disable no-undef */
/* eslint-disable complexity */
let isTemporarilyDisabled = false;

const handleOtpCode = async (event, requestPath) => {
	document.getElementById('verify-otp-code').disabled = true;
	event.preventDefault();
	const birthKit = requestPath.includes('birth-kit-signup');

	const errorElement = document.querySelector('.otp-code-error-banner.hidden');
	const errorClass = '.otp-code-error-banner';
	if (!errorElement) {
		hiddenError(errorClass);
	}

	let errorType = 'somethingWrong';
	const otpCode = document.getElementById('otpCodeId').value;
	const baseUrl = birthKit ? `${PROXY}/birth-kit` : `${PROXY}/membership`;
	try {
		toggleLoadingBtn('otp-code');
		const response = await fetch(`${baseUrl}/otp/verify`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			// phoneNumber variable is from verify-customer-id file
			body: JSON.stringify({ otpCode, uuid: sessionStorage.getItem('otp-uuid') }),
		});

		if (!response.ok) {
			throw new Error('somethingWrong');
		}

		const jsonResponse = await response.json();
		if (!jsonResponse.success) {
			errorType = jsonResponse.message ?? 'somethingWrong';
			throw new Error(errorType);
		}
		const redirectUrl = jsonResponse?.response ? jsonResponse.response.redirectUrl : jsonResponse?.redirectUrl;
		const redirectSource = jsonResponse?.data === 'birthKit' ? 'birth-kit' : 'membership';

		if (redirectSource) {
			sessionStorage.setItem('redirect-source', redirectSource);
		}
		if (redirectUrl) {
			window.location.replace(redirectUrl);
		} else {
			closeOtpLoginPopup('otp-code');
			openOtpLoginPopup(null, 'shopify-register', jsonResponse?.customerData);
		}
	} catch (error) {
		console.error('error:', error);
		showError(errorClass, errorType);
	} finally {
		toggleLoadingBtn('otp-code');
		document.getElementById('verify-otp-code').disabled = false;
	}
};

const sendCodeAgain = async (requestPath) => {
	if (isTemporarilyDisabled) {
		return;
	}
	tempDisableCodeRequest();
	const birthKit = requestPath.includes('birth-kit-signup');
	const baseUrl = birthKit ? `${PROXY}/birth-kit` : `${PROXY}/membership`;
	
	isTemporarilyDisabled = true;
	return new Promise((resolve) => {
		grecaptcha.ready(async () => {
			try {
				const captchaToken = await grecaptcha.execute('6LfQlyAqAAAAAEoCCRS81zjJuBwkoBNghyXp4_kA', { action: 'OTP_RESEND' });
				const response = await fetch(`${baseUrl}/otp/resend`, {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({ uuid: sessionStorage.getItem('otp-uuid'), captchaToken }),
				});
				const jsonResponse = await response.json();
				resolve(jsonResponse);
			} catch (error) {
				console.log('error', error);
				showError(errorClass, 'somethingWrong');
				resolve();
			}
		});
	});
};

function tempDisableCodeRequest() {
	const container = document.querySelector('[popup-type="otp-code"] .image-with-text__content');
	const sendAgainElement = container.querySelector('.send-code-again-link');
	const timerMessageElement = container.querySelector('.timer-message');
	sendAgainElement.style.display = 'none';
	const DELAY = 30;
	const timerElement = timerMessageElement.querySelector('.timer');
	timerElement.textContent = ('' + DELAY).padStart(2, '0');
	timerMessageElement.classList.remove('hidden');
	const timer = getTimer(DELAY, (sec) => {
		timerElement.textContent = ('' + sec).padStart(2, '0');
	});
	timer();

	setTimeout(() => {
		sendAgainElement.style.display = '';
		isTemporarilyDisabled = false;
		timerMessageElement.classList.add('hidden');
	}, DELAY * 1000);
}

function getTimer(seconds, cb) {
	const requestAnimFrame = (function () {
		return (
			window.requestAnimationFrame ||
			window.webkitRequestAnimationFrame ||
			window.mozRequestAnimationFrame ||
			function (callback) {
				window.setTimeout(callback, 1000 / 60);
			}
		);
	})();

	let _seconds = seconds;
	let lastTime = new Date().getTime();
	let currentTime = new Date().getTime();

	function _timer() {
		if (_seconds == 0) {
			return;
		}
		requestAnimFrame(_timer);
		currentTime = new Date().getTime();

		if (currentTime - lastTime >= 1000) {
			lastTime = currentTime;
			_seconds--;
			cb(_seconds);
		}
	}

	return _timer;
}
